<style>
.v-label {
  font-size: 14px;
}
</style>
<template>
<div>
  <v-card text>
    <v-container>
      <v-row>
        <v-card-title>
          <span class="headline">INFORMOVANÝ SOUHLAS SE ZPRACOVÁNÍM OSOBNÍCH ÚDAJŮ</span>
        </v-card-title>
        <v-card-text>
          <div>Tímto dávám {{ instDativDesc }}, se sídlem {{ this.institution.contactAddress.shortFriendlyAddress }}, IČ: {{ this.institution.ico }}, DIČ: {{ this.institution.dic }} (dále jen „správce“)
            výslovný souhlas ke zpracování následujících osobních údajů (vyhovující zaškrtněte):</div>
          <v-col mt-2 mb-3 offset-xs1>
            <my-gdpr v-model="this.customerData.gdprStates"></my-gdpr>
          </v-col>
          <div>které jsem správci sám/sama sdělil/a.</div>
          <div>Zpracování osobních údajů je uskutečňováno správcem.</div>
          <div>Čestně prohlašuji, že osobní údaje, které jsem poskytl/a jsou přesné, pravdivé a úplné.</div>
          <div>Tento souhlas je udělen na dobu určitou, a to na dobu trvání vymezeného účelu.</div>
          <div>Tento souhlas je dobrovolný. Prohlašuji, že poskytnutím souhlasu nebylo podmíněno plnění či uzavření smlouvy ani poskytnutí jiné služby.</div>
          <div>Tento souhlas může být kdykoliv odvolán. Odvoláním souhlasu není dotčena zákonnost zpracování vycházejícího ze souhlasu, který byl dán před jeho odvoláním.</div>
          <div>Tímto také beru na vědomí, že správce přijal Zásady ochrany osobních údajů, kde se dočtu více o zpracování osobních údajů a mých právech. Kdykoli se také mohu obrátit na pověřence pro ochranu osobních údajů na e-mailové adrese <a
              href="mailto:advokat@kklegal.cz">advokat@kklegal.cz</a>.</div>
          <div v-if="instAboutAgreement !== null">Aktuální informace o pověřenci naleznu také <a :href="instAboutAgreement" target="_blank">zde</a>.</div>
        </v-card-text>
        <v-col class="text-center" xs="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" @click.native="doAgreement" v-on="on">{{ $t('Uděluji souhlas') }}</v-btn>
            </template>
            <span>{{ $t('Stisknutím stisknutím udělíte souhlas') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</div>
</template>
<script>
import CustomerMixin from '@/mixins/customer-mixin.js'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import MyGdpr from '@/components/my-gdpr.vue'
export default {
  mixins: [CustomerMixin, InstitutionMixin],
  components: {
    'my-gdpr': MyGdpr
  },
  methods: {
    doAgreement() {
      this.setGdprStates(this.customerData.gdprStates)
    }
  }
}
</script>
